import React, { Component } from "react";
import { Grid, Button, GridColumn, Icon } from "semantic-ui-react";
import PeriodSlider from "./PeriodSlider";
import EventSlider from "./EventSlider";
import EventSliderIndex from "./EventSliderIndex";
import EventsCategoryIndicator from "./../Shared/EventsCategoryIndicator";
import { FixedSizeList as List } from "react-window";
import { Link } from "react-router-dom";
// import axios from "axios";
const sampleData = require("./data/sampleData.json");
const { apiUrl } = require('./config')

   function go() {
    var querystring = window.location.search.replace(/^\?/, '');
    // console.log('querystring',querystring)
    var params = {};
    querystring.replace(/([^=&]+)=([^&]*)/g, function (m, key, value) {
      // console.log('querystringkey',key, value)
    params[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    const token = encodeURIComponent(params['token'])
    // console.log('token',token)
    // console.log('paramtoken',params['token'])
    const content_type = encodeURIComponent(params['content_type'])
    // console.log('content_type',content_type)
    
    return `${apiUrl}/api/v2/page_preview/1/?content_type=${content_type}&token=${token}&format=json`
   }



class Timeline extends Component {
   state = {
     eventItem: {}
   }


  componentWillMount = () => {
    //go();
    var that = this;
    var url = go()
    // console.log("url00x1", url)
    fetch(url, { credentials: 'include', })
    .then(function (response) {
    // console.log(params)
    return response.json()
    })
    .then(function(data){
      // console.log("dataa00xxx", data)
      that.setState({
        eventItem: data
      })
    })
    .catch(err => console.log(err))
  };
  render() {
    // console.log("sampleData", go())
    // console.log("states", this.state);
    return (
      <div>
        {/* <PeriodCover {...this.state} /> */}
        <EventSlider {...this.state}/>
      </div>
    );
  }
}

export default Timeline;

